import { Link } from "react-router-dom";

const LINKS = [
  { to: "/", label: "Desk" },
  { to: "/vault", label: "Vault" },
  { to: "/prompts", label: "Prompts" },
  { to: "/ritual", label: "Ritual" },
  { to: "/projects", label: "Projects" },
  { to: "/whats-new", label: "What's new" },
];

export function Footer({ note }: { note: string }) {
  return (
    <footer>
      <div className="wrap footer-row">
        <p className="footer-note">{note}</p>
        <nav className="footer-links" aria-label="Footer">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to}>
              {l.label}
            </Link>
          ))}
        </nav>
      </div>
    </footer>
  );
}
